import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { HttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  
  constructor(private authService: HttpService) {}

  canActivate(): boolean | UrlTree {
    
    // Simply check authentication status
    // AuthService will handle toast and redirect if needed
    if (!this.authService.isAuthenticated()) {
      // this.authService.handleSessionExpired(true);
      return false;
    }
    
    return true;
  }

  canActivateChild(): boolean | UrlTree {
  return this.canActivate();
}
}